import { MigrationFromType } from "../../services/IntegrationApi";

export const FROM_TYPE_LABELS: Record<MigrationFromType, string> = {
  ACCSFApi: "ACC",
  TenantKey: "TenantKey",
  ENTRATA: "Entrata",
};

export const resolveFromType = (
  importType: string | null | undefined
): MigrationFromType => {
  if (importType === "TenantKey") return "TenantKey";
  if (importType === "ENTRATA") return "ENTRATA";
  return "ACCSFApi";
};

// "entrata"   — ACC/TenantKey → Entrata: configure, upload CSV, validate & confirm.
// "tenantkey" — ACC → TenantKey: configure, optional CSV upload, confirm & migrate.
// "legacy"    — everything else: single-screen form.
export type MigrationFlowKind = "entrata" | "tenantkey" | "legacy";

const ENTRATA_SOURCES = new Set(["ACCSFApi", "TenantKey"]);

export const getMigrationFlowKind = (
  importType: string | null | undefined,
  targetType: string
): MigrationFlowKind => {
  if (!importType || !targetType) return "legacy";
  if (targetType === "Entrata" && ENTRATA_SOURCES.has(importType)) return "entrata";
  if (importType === "ACCSFApi" && targetType === "TenantKey") return "tenantkey";
  return "legacy";
};

export const isWizardFlow = (kind: MigrationFlowKind): boolean => kind !== "legacy";

export const WIZARD_STEPS = ["Configure", "Upload CSV", "Confirm"] as const;
export const TOTAL_STEPS = WIZARD_STEPS.length;
